// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screener-advanced-criteria-select-options {
  display: flex;
  flex-direction: column;
}

.screener-advanced-criteria-select-option-item-container {
  box-sizing: border-box;
  min-height: 40px;

  padding: 12px 16px;

  cursor: pointer;
  transition-property:
    color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-duration: 150ms;

  &:hover {
    background-color: var(--color-brand-hover2);
  }
  &[id='all'] {
    border-bottom: 1px dashed #e0e0e0;
  }
}

.screener-advanced-criteria-select-option-item-toggle-button {
  display: flex;
  align-items: center;
  gap: 8px;

  width: 100%;
  height: 100%;
}

.screener-advanced-criteria-select-option-item-toggle-button-checkbox {
  width: 24px;
  height: 24px;
}

.screener-advanced-criteria-select-option-item-toggle-button-checkbox svg {
  width: 24px;
  height: 24px;

  & > path:first-child {
    fill: var(--color-brand);
  }
}

.screener-advanced-criteria-select-option-item-toggle-button-label {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  color: var(--text-primary);
  text-align: left;
  text-wrap: nowrap;
}

.screener-advanced-criteria-select-options-group-label {
  box-sizing: border-box;
  height: 48px;
  margin-bottom: 4px;
  padding: 12px 16px;
  background: var(--surface-senary);
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
  text-align: left;
}

.screener-advanced-criteria-select-no-criteria-selected-label {
  box-sizing: border-box;

  padding: 12px 0px;

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #1e1f2f;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Screener/Criteria/ScreenerCriteriaSelect/ScreenerCriteriaSelect.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;;EAEhB,kBAAkB;;EAElB,eAAe;EACf;8EAC4E;EAC5E,0BAA0B;;EAE1B;IACE,2CAA2C;EAC7C;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;;EAEtB,iBAAiB;;EAEjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".screener-advanced-criteria-select-options {\n  display: flex;\n  flex-direction: column;\n}\n\n.screener-advanced-criteria-select-option-item-container {\n  box-sizing: border-box;\n  min-height: 40px;\n\n  padding: 12px 16px;\n\n  cursor: pointer;\n  transition-property:\n    color, background-color, border-color, text-decoration-color, fill, stroke;\n  transition-duration: 150ms;\n\n  &:hover {\n    background-color: var(--color-brand-hover2);\n  }\n  &[id='all'] {\n    border-bottom: 1px dashed #e0e0e0;\n  }\n}\n\n.screener-advanced-criteria-select-option-item-toggle-button {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  width: 100%;\n  height: 100%;\n}\n\n.screener-advanced-criteria-select-option-item-toggle-button-checkbox {\n  width: 24px;\n  height: 24px;\n}\n\n.screener-advanced-criteria-select-option-item-toggle-button-checkbox svg {\n  width: 24px;\n  height: 24px;\n\n  & > path:first-child {\n    fill: var(--color-brand);\n  }\n}\n\n.screener-advanced-criteria-select-option-item-toggle-button-label {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n\n  color: var(--text-primary);\n  text-align: left;\n  text-wrap: nowrap;\n}\n\n.screener-advanced-criteria-select-options-group-label {\n  box-sizing: border-box;\n  height: 48px;\n  margin-bottom: 4px;\n  padding: 12px 16px;\n  background: var(--surface-senary);\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n  text-align: left;\n}\n\n.screener-advanced-criteria-select-no-criteria-selected-label {\n  box-sizing: border-box;\n\n  padding: 12px 0px;\n\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: #1e1f2f;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
